import React, { useRef, useState, useEffect } from "react";
import { Volume2, VolumeX } from "lucide-react";

const AmbientAudio = () => {
    const [on, setOn] = useState(false);
    const engine = useRef(null);

    const start = () => {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        const ctx = new Ctx();
        const master = ctx.createGain();
        master.gain.value = 0;
        const filter = ctx.createBiquadFilter();
        filter.type = "lowpass";
        filter.frequency.value = 420;
        filter.connect(master);
        master.connect(ctx.destination);

        // deep two-oscillator pad, gently detuned
        const oscA = ctx.createOscillator();
        oscA.type = "sine";
        oscA.frequency.value = 82.4;
        const oscB = ctx.createOscillator();
        oscB.type = "triangle";
        oscB.frequency.value = 123.5;
        oscB.detune.value = 6;
        const gainB = ctx.createGain();
        gainB.gain.value = 0.35;
        oscA.connect(filter);
        oscB.connect(gainB);
        gainB.connect(filter);

        // slow breathing LFO on the master gain
        const lfo = ctx.createOscillator();
        lfo.frequency.value = 0.08;
        const lfoGain = ctx.createGain();
        lfoGain.gain.value = 0.018;
        lfo.connect(lfoGain);
        lfoGain.connect(master.gain);

        oscA.start();
        oscB.start();
        lfo.start();
        master.gain.linearRampToValueAtTime(0.045, ctx.currentTime + 2.5);
        engine.current = { ctx, master };
    };

    const stop = () => {
        if (!engine.current) return;
        const { ctx, master } = engine.current;
        master.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.6);
        setTimeout(() => ctx.close(), 800);
        engine.current = null;
    };

    const toggle = () => {
        if (on) {
            stop();
            setOn(false);
        } else {
            start();
            setOn(true);
        }
    };

    useEffect(() => () => engine.current?.ctx.close(), []);

    return (
        <button
            data-testid="ambient-audio-toggle"
            onClick={toggle}
            aria-label={on ? "Mute ambient sound" : "Play ambient sound"}
            className={`glass-panel fixed bottom-6 left-6 z-50 flex h-11 w-11 items-center justify-center rounded-full transition-transform duration-200 hover:scale-110 ${
                on ? "text-neon-pink glow-pink" : "text-white/50"
            }`}
        >
            {on ? <Volume2 size={18} /> : <VolumeX size={18} />}
        </button>
    );
};

export default AmbientAudio;
